export default function momentShareUrl(landing_page_url: string, m_id: Number | null) {
  const socialShareUrl = new URL(landing_page_url)
  if (m_id) {
    socialShareUrl.searchParams.set("moment", `${m_id}`);
  } else {
    socialShareUrl.hash = "aw-fw";
  }
  return socialShareUrl.href
}
